module.exports = __webpack_public_path__ + "img/nakliyat-sigortasi.0df4ded3.png";